import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { CategoryMenu, colorCodes } from "../utils/constants";

const Filters = (props: any) => {
  const { className, showColor, filter } = props;

  const menuOptions = CategoryMenu.get(filter ? filter : "all") || [];
  const colors = Array.from(colorCodes.keys());
  const [selectedColor, setSelectedColor] = useState("");

  return (
    <Wrapper className={className}>
      <div className="content">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* categories */}
          <div className="form-control">
            <div>
              {menuOptions.map((option, index) => {
                return (
                  <Link to={option.link} key={index}>
                    <button
                      name="category"
                      type="button"
                      className={"category"}
                    >
                      {option.label}
                    </button>
                  </Link>
                );
              })}
            </div>
          </div>
          <hr />

          {/* end categories */}
          {/* colors */}
          {showColor && (
            <div className="form-control">
              <h2>Color</h2>
              <div className="colors">
                {colors.map((c, index) => {
                  if (c === "all") {
                    return (
                      <button
                        key={index}
                        name="color"
                        data-color="all"
                        className={"all-btn"}
                      >
                        all
                      </button>
                    );
                  }
                  return (
                    <button
                      key={index}
                      name="color"
                      style={{
                        background: colorCodes.get(c),
                        border: c === "white" ? "1px solid #979797" : undefined,
                      }}
                      onClick={() => setSelectedColor(c)}
                      className={"color-btn"}
                      data-color={c}
                    >
                      {selectedColor === c ? (
                        <FaCheck
                          style={{ color: c === "white" ? "#666" : "#FFF" }}
                        />
                      ) : null}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {/* end of colors */}
        </form>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
    .form-control {
      margin-bottom: 1.25rem;
      width: max-content;
      
      h2 {
        font-family: HelveticaNeue-Bold;
        font-size: 18px;
        color: #090A0A;
      }
    }

    .filter-title {
      font-family: HelveticaNeue-Bold;
      font-size: 24px;
      color: #090A0A;
    }

    .category {
      font-family: HelveticaNeue-Medium;
      font-size: 18px;
      color: #090A0A;
    }
    
    hr {
      display: block;
      height: 1px;
      border: 0;
      border-top: 1px solid #D8D8D8;
      margin: 1em 0;
      padding: 0;
  }
  
    button {
      display: block;
      margin: 0.25em 0;
      padding: 0.25rem 0;
      text-transform: capitalize;
      background: transparent;
      border: none;
      border-bottom: 1px solid transparent;
      letter-spacing: var(--spacing);
      color: var(--clr-grey-5);
      cursor: pointer;
    }
    .active {
      border-color: var(--clr-grey-5);
    }

    .colors {
      display: grid;
      grid-template-columns: repeat(4, 26px);
      grid-template-rows: repeat(3, 26px);
      grid-column-gap: 12px;
      grid-row-gap: 10px;
      grid
    }
    .color-btn {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      svg {
        font-size: 0.8rem;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        color: white;
      }
    }
    .all-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.5rem;
      opacity: 0.5;
    }
    .all-btn .active {
      text-decoration: underline;
    }
    .price {
      margin-bottom: 0.25rem;
    }
    @media (min-width: 768px) {
      .content {
        position: sticky;
        top: 1rem;
      }
      .clear-btn {
      }
    }
  `;

export default Filters;
